import PropTypes from 'prop-types';

export const RankType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
});
